/**
 * 极验证工具
 */
import { apiFetch } from 'zn-common'

/**
 * 从服务器获取'极验'验证码信息
 */
export const getGtCaptchaInfo = async () => {
  return null
  const res = await apiFetch({ url: `captcha/register.do?t=${Date.now()}` }, {
    data: {
      type: '101',
      resourceType: '1'
    }
  })
  const { code } = res.body || {}
  // 100 是和后端约定的值，表示科技滑块验证服务暂不可用
  if (!res || res._failure || code === 100) {
    return null
  }
  return res.body
}

/**
 * 初始化极验滑块验证码，获取验证码对象
 * @param onSuccess 初始化成功
 * @param onFail 初始化失败
 */
export const initGtCaptcha = async (onSuccess, onFail) => {
  // 从服务器获取'极验'验证码信息
  const gtInfo = await getGtCaptchaInfo()
  if (!gtInfo) {
    onFail()
    return
  }
  const {
    gt, challenge, apiServer, staticServer
  } = gtInfo
  window.initGeetest({
    gt,
    challenge,
    offline: false,
    product: 'custom',
    // eslint-disable-next-line
    new_captcha: true,
    https: true,
    width: '100%',
    area: '#captcha-popup', // 必填参数
    // eslint-disable-next-line
    next_width: '300px',
    // eslint-disable-next-line
    bg_color: 'white',
    // eslint-disable-next-line
    api_server: apiServer,
    // eslint-disable-next-line
    static_servers: [staticServer],
    onError: onFail
  }, onSuccess)
}

export const isCaptchaPopupShow = () => {
  const popup = document.querySelector('.geetest_popup')
  if (!popup) {
    return false
  }
  return window.getComputedStyle(popup).display === 'block'
}

export const hideGeetestPopup = (captcha, targetEl) => {
  const popup = document.querySelector('.geetest_popup')
  if (isCaptchaPopupShow() && captcha && !popup?.contains(targetEl)) {
    captcha.hide()
  }
}
